module.exports = __webpack_public_path__ + "static/img/home_carousel_2.923a791.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mobile/english/home_carousel_2.png
// module id = Cuml
// module chunks = 15